export default {"src":"/_next/static/media/location.b5a45ef7.svg","height":20,"width":18,"blurWidth":0,"blurHeight":0};